import React from 'react';
import { Box } from '@mui/material';

function CustomTabPanel({ children, label }: { children: React.ReactNode, label: string }) {
  return (
    <Box
      role="tabpanel"
      id={`hub-tabpanel-${label}`}
      aria-labelledby={`hub-tab-${label}`}
    >
      {children}
    </Box>
  );
}

export default CustomTabPanel;
